import api from './api';

export interface EvaluationCriteria {
    category: string;
    criterionCode: string;
    criterionName: string;
    rating: number; // 0, 1, 2
    ratingLabel: string;
    observations: string;
}

export interface OperationEvaluation {
    id?: number;
    operationId: number;
    evaluatorId: number;
    generalObservations: string;
    recommendations: string;
    criteria: EvaluationCriteria[];
    totalScore?: number;
    opcLevel?: string;
    status: string;
    evaluationDate?: string;
}

export const evaluationService = {
    getAll: async () => {
        const response = await api.get('/api/v1/evaluations');
        return response.data;
    },

    getById: async (id: number) => {
        const response = await api.get(`/api/v1/evaluations/${id}`);
        return response.data;
    },

    create: async (evaluation: OperationEvaluation) => {
        const response = await api.post('/api/v1/evaluations', evaluation);
        return response.data;
    },

    getPatterns: async () => {
        const response = await api.get('/api/v1/evaluations/analytics/patterns');
        return response.data;
    },

    downloadPdf: async (evaluationId: number) => {
        const REPORTS_API_URL = import.meta.env.VITE_REPORTS_API_URL || 'http://localhost:8000';
        const url = `${REPORTS_API_URL}/reports/api/v1/evaluation/${evaluationId}/`;

        const response = await fetch(url);
        if (!response.ok) throw new Error('Error downloading report');

        const blob = await response.blob();
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.setAttribute('download', `evaluacion_opc_${evaluationId}.pdf`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(downloadUrl);
    }
};
